import { memo, useRef, useState, useEffect, useCallback } from 'react';

import { ButtonColors } from 'types';
import { Icon } from 'components/icon';
import { Button } from 'components/button';

import { ResendButtonProps } from './types';

export const ResendButton = memo<ResendButtonProps>(({ onResend }) => {
  const [timeLeft, setTimeLeft] = useState(0);
  const timerRef = useRef<number | null>(null);

  const startTimer = useCallback(() => {
    setTimeLeft(60);

    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    timerRef.current = window.setInterval(() => {
      setTimeLeft((t) => {
        if (t <= 1 && timerRef.current) {
          clearInterval(timerRef.current);
          return 0;
        }
        return t - 1;
      });
    }, 1000);
  }, []);

  const handleClick = () => {
    startTimer();
    onResend();
  };

  useEffect(() => {
    startTimer();
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current!);
      }
    };
  }, []);

  return (
    <Button
      transparent
      padding="0"
      onClick={handleClick}
      icon={<Icon.Repeat />}
      disabled={timeLeft > 0}
      colorType={ButtonColors.LightBlue}
      text={`Re-send code${timeLeft > 0 ? ` in ${timeLeft}s` : ''}`}
    />
  );
});
